import { Header } from './Header';
import { Footer } from './Footer';
import { FadeInWhenVisible } from './Animations';
import { LegalHero } from './LegalHero';
import { useLanguage } from '../context/LanguageContext';
import { LEGAL } from '../i18n/legal';

const Section = ({ s }) => {
  const [heading, before, items, after] = s;
  return (
    <>
      <h2>{heading}</h2>
      {before && <p>{before}</p>}
      {items && <ul>{items.map((it) => <li key={it}>{it}</li>)}</ul>}
      {after && <p className="mt-4">{after}</p>}
    </>
  );
};

export const LegalPage = ({ doc, testId }) => {
  const { language } = useLanguage();
  const pack = LEGAL[language] || LEGAL.en;
  const d = pack[doc];

  return (
    <div className="min-h-screen bg-[#080808]" lang={language} data-testid={testId}>
      <Header />
      <LegalHero title={d.title} eyebrow={pack.eyebrow} />
      <section className="px-6 lg:px-12 pb-32">
        <div className="max-w-[1100px] mx-auto">
          <FadeInWhenVisible>
            <div className="max-w-[72ch]">
              <div className="legal-prose lux-prose" lang={language} data-testid="legal-content">
                <p className="text-lg text-white/80 mb-8">{d.intro}</p>
                <p className="text-white/60 mb-8 p-4 border-l-4 border-[#C8AA73]">{d.note}</p>
                {d.sections.map((s) => <Section key={s[0]} s={s} />)}
                <p className="text-[#C8AA73] font-semibold">info@softmaya.com</p>
              </div>
            </div>
          </FadeInWhenVisible>
        </div>
      </section>
      <Footer />
    </div>
  );
};
